'use strict';
angular.module('manageconfigManageNewsModule', [])
    .controller('manageNewsCtrl', ['$scope', 'selectedItem', '$q', '$modalInstance', '$timeout', '$validation', 'trsHttpService', 'initManageConSelectedService', 'modalDialog', function($scope, selectedItem, $q, $modalInstance, $timeout, $validation, trsHttpService, initManageConSelectedService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_paperset',
                methodname: 'findPaperById'
            };
            $scope.partterns = initManageConSelectedService.getPartterns();
            $scope.appearances = initManageConSelectedService.getAppearances();
            $scope.genres = initManageConSelectedService.getGenres();
            $scope.iscancelsign = initManageConSelectedService.isCancelSign();
            $scope.newspaper = {
                NEEDWITHDRAWCHECK: 0,
                DISPLAYFGDLIST: 0,
                CHECKFGDATTRIBUTE: 0,
                ISDUOJISHEN: 1,
                ISZHAOPAI: 1,
                DATAPATH: 1,
                INCLUDEDIECI: 0,
                LIMITEDAENUMBER: 0,
                REPEATUSETIME: 0,
                CKMSIMDAYRANGE: 0,
                ISORIGINAL: 1
            };
            $scope.isJudge = false;
        }

        /**
         * [initData description]
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            selectedItem !== '' ? requestData() : '';
            selectedItem !== '' ? $scope.paperTtile = '编辑纸媒' : $scope.paperTtile = '新建纸媒';
            $scope.isJudge = selectedItem ? $scope.newspaper.ISORIGINAL == '1' : false;
        }

        /**
         * [requestData description]
         *
         * @return  {[type]}   [return description]
         */
        function requestData() {
            $scope.params.SiteId = selectedItem.SITEID;
            var deferred = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.newspaper = data;
                deferred.resolve();
            });
            return deferred.promise;
        }
        // 审核模式
        $scope.selectPattern = function(pattern) {
            $scope.newspaper.ISDUOJISHEN = pattern.value;
        };
        // 照排版面
        $scope.selectAppearance = function(appearance) {
            $scope.newspaper.ISZHAOPAI = appearance.value;
        };
        // 照排类型
        $scope.selectGenre = function(genre) {
            $scope.newspaper.DATAPATH = genre.value;
        };
        // 取消签发是否校验
        $scope.selectIsCancelSign = function(value){
            $scope.newspaper.NEEDWITHDRAWCHECK = value.value;
        };

        /**
         * [isSelectedCheckbox description]是否选中单选框
         * @param  {[type]}  key [description]属性值
         * @return {Boolean}     [description]
         */
        $scope.isSelectedCheckbox = function(key) {
            $scope.newspaper[key] = $scope.newspaper[key] == 1 ? 0 : 1;
        };
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [deleteProducts description]
         *
         * @return  {[type]}   [return description]
         */
        function deleteProducts(){
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'deleteProduct',
                PRODUCTID: parseInt($scope.newspaper.SITEID),
                MEDIATYPE: 3
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data){

            });
        }

        /**
         * [submit description]
         *
         * @return  {[type]}   [return description]
         */
        function submit() {
            $scope.params.SiteId = selectedItem.SITEID;
            var deferred = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {                
                if ($scope.isJudge && $scope.params.ISORIGINAL == '0'){
                    deleteProducts();
                }
                deferred.resolve();
            });
            return deferred.promise;
        }
        $scope.confirm = function() {
            $validation.validate($scope.manageNewsform).success(function() {
                $scope.params.methodname = 'savePaper';
                $scope.params.ObjectId = selectedItem.SITEID;
                $scope.params.SITENAME = $scope.newspaper.SITENAME;
                $scope.params.SITEDESC = $scope.newspaper.SITEDESC;
                $scope.params.WEBHTTP = $scope.newspaper.WEBHTTP;
                $scope.params.ISDUOJISHEN = $scope.newspaper.ISDUOJISHEN;
                $scope.params.ISZHAOPAI = $scope.newspaper.ISZHAOPAI;
                $scope.params.DATAPATH = $scope.newspaper.DATAPATH;
                $scope.params.NeedWithDrawCheck = $scope.newspaper.NEEDWITHDRAWCHECK;
                $scope.params.DISPLAYFGDLIST = $scope.newspaper.DISPLAYFGDLIST;
                $scope.params.CHECKFGDATTRIBUTE = $scope.newspaper.CHECKFGDATTRIBUTE;
                $scope.params.LIMITEDAENUMBER = $scope.newspaper.LIMITEDAENUMBER === '' ? 0 : $scope.newspaper.LIMITEDAENUMBER;
                $scope.params.INCLUDEDIECI = $scope.newspaper.INCLUDEDIECI;
                $scope.params.REPEATUSETIME = $scope.newspaper.REPEATUSETIME === '' ? 0 : $scope.newspaper.REPEATUSETIME;
                $scope.params.CKMSIMDAYRANGE = $scope.newspaper.CKMSIMDAYRANGE === '' ? 0 : $scope.newspaper.CKMSIMDAYRANGE;
                $scope.params.FtCheckDocUrl = $scope.newspaper.FTCHECKDOCURL === '0' ? '' : $scope.newspaper.FTCHECKDOCURL;
                $scope.params.ISORIGINAL = $scope.newspaper.ISORIGINAL;
                submit().then(function(data) {
                    modalDialog.alertType('提交成功', '', 'success', false, function() {
                        $modalInstance.close('success');
                    });
                });
            }).error(function() {
                $scope.showAllTips = true;
                modalDialog.alertType('提交失败', '请检查表单', 'info', false, function() {});
            });
        };
    }]);
